import { AxiosResponse } from "axios";

export class Notification {
    private dispatchSnackbarEvent(message: string, color: string, sticky: boolean = false) {
        var event = new CustomEvent('snackbar', { bubbles: true, detail: { message, color, sticky } });
        dispatchEvent(event);
    }

    public showSnackbar(response: AxiosResponse, message?: string) {
        var displayMsg = "";
        if (message) {
            displayMsg = message;
        }

        if (response) {
            if (!displayMsg) {
                displayMsg = response && response.data ? response.data : response.statusText;
            }

            if (response.status == 200) {
                this.dispatchSnackbarEvent(displayMsg, NotificationType[NotificationType.success]);
            } else {
                this.dispatchSnackbarEvent(displayMsg, NotificationType[NotificationType.error]);
            }
        } else { //Fallback message
            if (!displayMsg) {
                displayMsg = 'An error occurred';
            }

            this.dispatchSnackbarEvent(displayMsg, NotificationType[NotificationType.error]);
        }
    }

    public showSnackbarMessage(message: string, type: NotificationType) {
        if (type == NotificationType.success) {
            this.dispatchSnackbarEvent(message, NotificationType[NotificationType.success]);
        } else {
            this.dispatchSnackbarEvent(message, NotificationType[NotificationType.error], true);
        }
    }

    public Error(message: string) {
        this.dispatchSnackbarEvent(message, NotificationType[NotificationType.error], true);
    }

    public Success(message: string) {
        this.dispatchSnackbarEvent(message, NotificationType[NotificationType.success]);
    }
}

export enum NotificationType {
    success = 1,
    error = 2
}
